(function(){
function init(root){
var form=root.querySelector('#waqt-cart-form');if(!form)return;
var status=root.querySelector('[data-cart-status]');
var endpoint=root.getAttribute('data-change-endpoint')||'/cart/change.js';
var busy=false;
function show(s){if(status)status.textContent=s||'';}
function pending(isPending){busy=isPending;form.setAttribute('aria-busy',String(busy));root.querySelectorAll('[data-minus],[data-plus],[data-cart-qty],[data-update],[data-checkout]').forEach(function(e){e.disabled=busy;});}
function normalized(n){var value=Number(n);return Number.isFinite(value)?Math.max(1,Math.min(99,Math.floor(value))):1;}
async function save(line,input,n){
if(busy)return;
var original=normalized(Number(line.dataset.originalQty)),newQty=normalized(n);
input.value=newQty;
if(original===newQty)return;
show('Updating your bag…');pending(true);
try{
var response=await fetch(endpoint,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.dataset.lineKey,quantity:newQty})});
var result=await response.json().catch(function(){return {};});
if(!response.ok||(typeof result.status==='number'&&result.status>=400))throw Error(result.description||result.message||'Could not update your bag.');
window.location.reload();
}catch(err){pending(false);input.value=original;show(err.message||'Could not update your bag. Please try again.');}
}
root.querySelectorAll('[data-cart-line]').forEach(function(line){
var input=line.querySelector('[data-cart-qty]');if(!input)return;
var minus=line.querySelector('[data-minus]'),plus=line.querySelector('[data-plus]');
if(minus)minus.addEventListener('click',function(){save(line,input,Number(input.value)-1);});
if(plus)plus.addEventListener('click',function(){save(line,input,Number(input.value)+1);});
input.addEventListener('change',function(){save(line,input,Number(input.value));});
var remove=line.querySelector('[data-cart-remove]');
if(remove)remove.addEventListener('click',function(event){if(busy)event.preventDefault();});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-waqt-cart-v2]').forEach(init);});
else document.querySelectorAll('[data-waqt-cart-v2]').forEach(init);
})();
